module.exports = __webpack_public_path__ + "static/media/2.02d321a3.webp";